import { useQuery } from "react-query";
import { APIError } from "../api";
import { getFullPost } from "./get-full-post";

export function useFullPost(item) {
  const itemType = item.post_type === "post" ? "posts" : item.post_type;
  const itemTypeForPath =
    item.post_type === "post" ? "articles" : `${item.post_type}s`;
  const result = useQuery<any, APIError>(
    ["full-post", item.post_name, itemType],
    getFullPost
  );

  return { result, itemTypeForPath };
}
